import React from 'react';
import {Table as BaseTable} from 'reactstrap';
import {TableProps} from 'reactstrap/types/lib/Table';

export default class Table extends React.Component<TableProps> {
    render() {
        return <BaseTable {...this.props}/>;
    }
}
